// extracted by mini-css-extract-plugin
export default {"custom-edit-container":"CustomDetails_custom-edit-container__V-5uH","button":"CustomDetails_button__fCfT-"};